export enum BackoffStrategy {
    Exponential = 'exponential'
}
